<template>
  <div>
    <div v-if="step == 'form'">
      <div class="row">
        <div class="col-md-10 col-lg-10 col-xl-10">
          <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
            <input type="text" class="form-control" v-model="contact.name" placeholder="Ваше имя">
            <p class="help-block" v-if="errors.name">
              {{ errors.name.join(', ') }}
            </p>
          </div>
        </div>
        <div class="col-md-10 col-lg-10 col-xl-10">
          <div class="form-group" v-bind:class="{ 'has-error': errors.city }">
            <input type="text" class="form-control" v-model="contact.city"
            placeholder="Ваш город">
            <p class="help-block" v-if="errors.city">
              {{ errors.city.join(', ') }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group" v-bind:class="{ 'has-error': errors.phone }">
        <input type="text" class="form-control" v-model="contact.phone"
        placeholder="Контакты для ответа (Email, телефон или мессенджеры)">
        <p class="help-block" v-if="errors.phone">
          {{ errors.phone.join(', ') }}
        </p>
      </div>
      <div class="form-group">
        <textarea rows="4" class="form-control feedback__textarea" placeholder="Ваш вопрос"></textarea>
      </div>
      <div class="form-bottom accept">
        <button type="button" class="btn btn-primary feedback__btn accept-btn" v-on:click="sendForm">Отправить</button>
        <p class="accept-text">Отправляя сообщение вы принимаете
          <a href="/legal/">условия обработки персональных данных</a>
        </p>
      </div>
    </div>

    <div v-if="step == 'complete'">
      <p class="text-success">
        Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'QuestionForm',
  props: ['template'],
  data() {
    return {
      contact: {},
      errors: {},
      step: 'form'
    }
  },
  mounted() {
    axios.get("/contacts/api/consult/").then(response => {this.contact = response.data});
  },
  methods: {
    sendForm: function () {
      axios.put("/contacts/api/consult/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
        ym(97921240,'reachGoal','CONTACT_MESSAGE');
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>

<style lang="scss">
</style>
